// There is SOO much shit in here FFS
import * as THREE from "three";
// This should not be a singleton
export const CameraPlane = {
    camera: null,
    farTopRight: null,
    farTopLeft: null,
    farBottomRight: null,
    farBottomLeft: null,

    nearTopRight: null,
    nearTopLeft: null,
    nearBottomRight: null,
    nearBottomLeft: null,

    compute: function (_camera) {
        this.camera = _camera;
        if (this.camera == null) {
            return;
        }
        let hFar = 2 * Math.tan(camera.fov * Math.PI / 180 / 2) * this.camera.far;
        let wFar = hFar * this.camera.aspect;

        this.farTopLeft = new THREE.Vector3(-wFar / 2, hFar / 2, -this.camera.far);
        this.farBottomRight = new THREE.Vector3(wFar / 2, -hFar / 2, -this.camera.far);
        this.farTopRight = new THREE.Vector3(wFar / 2, hFar / 2, -this.camera.far);
        this.farBottomLeft = new THREE.Vector3(-wFar / 2, -hFar / 2, -this.camera.far);
        
        //this.camera.updateMatrixWorld();
        //this.farTopLeft.applyMatrix4(this.camera.matrixWorld);
        //this.farBottomRight.applyMatrix4(this.camera.matrixWorld);
        //this.farTopRight.applyMatrix4(this.camera.matrixWorld);
        //this.farBottomLeft.applyMatrix4(this.camera.matrixWorld);

        let hNear = 2 * Math.tan(this.camera.fov * Math.PI / 180 / 2) * this.camera.near;
        let wNear = hNear * this.camera.aspect;

        this.nearTopLeft = new THREE.Vector3(-wNear / 2, hNear / 2, -this.camera.near);
        this.nearBottomRight = new THREE.Vector3(wNear / 2, -hNear / 2, -this.camera.near);
        this.nearTopRight = new THREE.Vector3(wNear / 2, hNear / 2, -this.camera.near);
        this.nearBottomLeft = new THREE.Vector3(-wNear / 2, -hNear / 2, -this.camera.near);

        // Why do we run applyMatrix here? it should not be needed right?
        //this.nearTopLeft.applyMatrix4(this.camera.matrixWorld);
        //this.nearBottomRight.applyMatrix4(this.camera.matrixWorld);
        //this.nearTopRight.applyMatrix4(this.camera.matrixWorld);
        //this.nearBottomLeft.applyMatrix4(this.camera.matrixWorld);

    },
};

// Generate the UVs required for an animated frame.
export var AnimatedFrame = {
    width: 1494,
    height: 1336,

    framesWide: 3,
    framesTall: 4,

    spriteIndex: function (index) {
        if (index < this.framesWide) {
            return [index, 0];
        }
        let y = Math.floor(index / this.framesWide);
        let offt = index - (this.framesWide * y);
        return [Math.round(offt), Math.round(y)];
    },

    // for quads
    getFrameCoords: function (index) {
        let result = [];

        let frame = this.spriteIndex(index);
        let x = frame[0];
        let y = frame[1];

        let tX = 1.0 / this.framesWide;
        let tY = 1.0 / this.framesTall;
        let xc = (tX * x);
        let yc = 1.0 - (tY * y);

        let x1 = xc;
        let y1 = yc;

        let x2 = x1 + tX;
        let y2 = y1;

        let x3 = x1;
        let y3 = y1 - tY;

        let x4 = x1 + tX;
        let y4 = y1 - tY;

        // ready for faceVertexUvs

        result.push([new THREE.Vector2(x3, y3), //a
            new THREE.Vector2(x1, y1), //b
            new THREE.Vector2(x2, y2), //c
        ]);

        result.push([new THREE.Vector2(x4, y4), //d
            new THREE.Vector2(x3, y3), //a
            new THREE.Vector2(x2, y2), //c
        ]);

        return result;
    }
};

// the various animated states will have different frames/types
// eslint-disable-next-line no-var
export const AnimatedState = (function () {
    this.name = "";
    this.frames = [];
    this.uvCache = {};
    this.currentFrame = 0;
    this.frameDelay = 20;
    this.lastUpdate = 0;

    this.setupWithFrames = function (_name, _frames) {
        this.currentFrame = 0;
        this.name = _name;
        this.frames = _frames.slice();
    };

    this.getFrameUVs = function () {
        let ct = currentTime();

        if (this.lastUpdate == 0) {
            this.lastUpdate = ct;
        }

        if ((ct - this.lastUpdate) >= 40) {
            this.currentFrame = this.currentFrame + 1;
            this.lastUpdate = ct;
            if (this.currentFrame > 11) {
                this.currentFrame = 0;
            }
        }

        // Cache UV storage so we don't have to perform math all the time
        //
        //
        let cached = this.uvCache[this.currentFrame.toString()];

        if (cached) {
            return cached;
        }
        cached = AnimatedFrame.getFrameCoords(this.currentFrame);
        this.uvCache[this.currentFrame.toString()] = cached;
        return cached;
    };
});

// This is a simple mesh/object with spirte sheet support
export var AnimatedObject = (function () {
    this.type = null;
    this.geometry = null;
    this.mesh = null;
    this.height = null;
    this.width = null;
    this.position = null;
    this.material = null;

    // needs to be configurable
    this.imageWidth = 1494;
    this.height = 1336;
    this.framesWide = 3;
    this.framesTall = 4;

    this.lastUpdate = new Date();
    this.currentAnimation = null;
    this.animations = [];
    this.animationRunning = false;
    this.currentFrame = 0;

    this.addAnimation = function (name, frames) {
        let state = new AnimatedState();
        state.setupWithFrames(name, frames);
        this.animations.push(state);
    };

    this.stopAnimation = function () {
    };

    this.startAnimation = function (name) {
        let animation = null;
        for (let i = 0; i < this.animations.length; i++) {
            let a = this.animations[i];
            if (a.name == name) {
                animation = a;
            }
        }
        if (animation == null) {
            return;
        }
        this.currentAnimation = animation;
        this.currentAnimation.currentFrame = 0;
        this.currentAnimation.lastUpdate = 0;
    };

    this.update = function () {
        let ct = currentTime();
        if (this.lastUpdate != null) {
            if ((ct - this.lastUpdate) < 1000 / 60) {
                return;
            }
        }
        this.geometry.faceVertexUvs[0] = this.currentAnimation.getFrameUVs();
        this.geometry.computeFaceNormals();
        this.geometry.computeVertexNormals();
        this.currentFrame = this.currentFrame + 1;
        if (this.currentFrame > 2) {
            this.currentFrame = 0;
        }
        this.geometry.uvsNeedUpdate = true;
        this.lastUpdate = currentTime();
    };
});

export var MaterialStore = {
    materials: [],
    get: function (name) {
        return this.materials[name];
    },
    set: function (name, data) {
        this.materials[name] = data;
    },
};

export var ShaderStore = {
    shaders: [],
    updateShaders: function () {
    },
    get: function (name) {
        if (name == "globals") {
            return this.shaders[name];
        }
        let globals = this.shaders["globals"];
        return globals + " \n " + this.shaders[name];
    },
    set: function (name, data) {
        this.shaders[name] = data;
    },
};

export var TextureStore = {
    textures: {},
    setTexture: function (name, texture) {
        texture.minFilter = THREE.NearestFilter;
        texture.magFilter = THREE.NearestFilter;
        this.textures[name] = texture;
    },
    getTexture: function (name) {
        return this.textures[name];
    },
    printTextures: function () {
    },
};

export var ModelStore = {
    models: {},
    setModel: function (name, mesh, geometry, materails) {
        let object = {};
        object["mesh"] = mesh;
        object["name"] = name;
        object["geometry"] = geometry;
        object["materials"] = materails;

        console.log("Adding ", name);
        this.models[name] = object;
    },
    getModel: function (name) {
        return this.models[name];
    },
    printTextures: function () {
    },
};

// https://github.com/mrdoob/three.js/blob/master/examples/webgl_loader_gltf.html
export var ObjectStore = {
    objects: [],
    addObject: function (obj) {
        this.objects.push(obj);
    },
    removeObject: function (obj) {
    },
    draw: function () {
    },
    update: function () {
        this.objects.forEach(function (o, i) {
            o.update();
        });
    },
};

// We need to add a animation mixer to each object (so we can animated them...)
export var ModelObjectStore = {
    objects: {},
    setObject: function (name, object) {
        this.objects[name] = object;
    },
    // We should probably clone the object here.
    getObject: function (name) {
        return this.objects[name];
    },
};

export var object = (function () {
    let obj;
    let type;
    let width;
    let height;
    let timeStart;
    let rotation = new AVector3();
    let scale = new AVector3();
});

export var ASphere2D = (function () {
});

export var ASphere3D = (function () {
    this.origin = new AVector3(0.0, 0.0, 0.0);

    this.theta = 0.0;
    this.phi = 0.0;
    this.radius = 0.0;

    this.target_phi = 0.0;
    this.target_theta = 0.0;
    this.target_radius = 0.0;

    this.FixIt = function (b) {
        let timeStep = 0.015;
        if (this.theta != b.theta) {
            this.theta = Lerp1D(this.theta,
                b.theta,
                timeStep);
        }
        if (this.phi != b.phi) {
            this.phi = Lerp1D(this.phi,
                b.phi,
                timeStep);
        }
    };

    this.print = function () {
        console.log(this.phi + " " + this.theta + " " + this.radius);
    };

    /* Add some good animation-interpolation methods */
    this.interp = function (b, step) {
    };

    this.convert = function () {
        let r = new AVector3();
        let x = Math.cos(this.theta) * Math.sin(this.phi) * this.radius;
        let z = Math.sin(this.theta) * Math.sin(this.phi) * this.radius;
        let y = Math.cos(this.phi) * this.radius;
        r.x = x + this.origin.x;
        r.y = y + this.origin.y;
        r.z = z + this.origin.z;
        return r;
    };
});

export var AVector3 = (function (x, y, z) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.print = function () {
        console.log(this.x + " " + this.y + " " + this.z);
    };
});

export var colors = (function () {
    let rgba2hex = function (rgba) {
        return 0x11223344;
    };
});

export function DEG2RAD(a) {
    return a * .017453292519943295; // (angle / 180) * Math.PI;
}

// 1D Lerp
export function Lerp1D(start, end, t) {
    let result = start + (end - start) * t;
    return result;
}

// AVector lerp
export function Lerp(start, end, t) {
    let result = new AVector3();
    result.x = start.x + (end.x - start.x) * t;
    result.y = start.y + (end.y - start.y) * t;
    result.z = start.z + (end.z - start.z) * t;
    return result;
}

// Very simple variable range mapping system
export function MapValue(value, toMin, toMax, fromMin, fromMax) {
    return toMin + (toMax - toMin) * ((value - fromMin) / (fromMax - fromMin));
}

export function Curve(P1, P2, CP1, CP2, t) {
    let result = new Vector3();
    let ab = Lerp(P1, CP1, t);
    let bc = Lerp(CP1, CP2, t);
    let cd = Lerp(CP2, P2, t);
    let abbc = Lerp(ab, bc, t);
    let bccd = Lerp(bc, cd, t);
    let dest = Lerp(abbc, bccd, t);
    return dest;
}

function placeSphere() {
}

export function smoothstep(min, max, value) {
    let x = Math.max(0, Math.min(1, (value - min) / (max - min)));
    return x * x * (3 - 2 * x);
}
// interpolate over a group of vectors (for various effects)
export function InterpVectors(v1, v2, t) {
}

export function currentTime() {
    return +new Date();
}

export function directionForDegrees(location, degrees, stepSize) {
    let result = new AVector3(0, 0, 0);
    let x = Math.cos(DEG2RAD(degrees)) * stepSize;
    let y = Math.sin(DEG2RAD(degrees)) * stepSize;
    result.x = location.x + x;
    result.y = location.y + y;
    result.z = location.z;
    return result;
}

// Simple method returns UVs from a sprite sheet
export function GetFrameCoords(index, framesWide, framesTall) {
    let result = [];
    let frame = index;

    let y = Math.floor(index / framesWide);
    let fX = Math.floor(Math.floor(framesWide) * y);
    let x = Math.floor(index - fX);

    let tX = 1.0 / framesWide;
    let tY = 1.0 / framesTall;
    let xc = (tX * x);

    let yc = 1.0 - (tY * y);

    // Kind of fixes it..
    //yc += tY/1.4;

    let x1 = xc;
    let y1 = yc;

    let x2 = x1 + tX;
    let y2 = yc;

    let x3 = x1;
    let y3 = y1 - tY;

    let x4 = x1 + tX;
    let y4 = y1 - tY;

    // ready for faceVertexUvs
    result.push([new THREE.Vector2(x3, y3), //a
        new THREE.Vector2(x1, y1), //b
        new THREE.Vector2(x2, y2), //c
    ]);

    result.push([new THREE.Vector2(x4, y4), //d
        new THREE.Vector2(x3, y3), //a
        new THREE.Vector2(x2, y2), //c
    ]);

    return result;
}


function GetFloorFrameCoords(index, framesWide, framesTall) {
    let result = [];
    let frame = index;


    let y = Math.floor(index / framesWide);
    let fX = Math.floor(Math.floor(framesWide) * y);
    let x = Math.floor(index - fX);

    let tX = 1.0 / framesWide;
    let tY = 1.0 / framesTall;

    let xc = (tX * x);

    let yc = 1.0 - (tY * y);


    xc += 0.00005;
    yc -= 0.00025;


    let x1 = xc;
    let y1 = yc;

    let x2 = x1 + tX;
    let y2 = yc;

    let x3 = x1;
    let y3 = y1 - tY;

    let x4 = x1 + tX;
    let y4 = y1 - tY;


    // 0,0  0,1, 1,1
    // 1,0  0,0  1,0

    // These are different from the other quad

    let A = new THREE.Vector2(x2, y2);
    let B = new THREE.Vector2(x1, y1);

    let C = new THREE.Vector2(x3, y3);
    let D = new THREE.Vector2(x4, y4);

    result.push([A, B, C]);
    result.push([D, A, C]);

    return result;
}


// Deal with

function GetFrameCoords2D(x, y, framesWide, framesTall) {

}

// This should take a offset tooS
function tiledXY(i, width, height) {
}

// Tiled index is weird in that it goes from 0-55, when our sprite UV mapping calculations
// Correctly go from 0 -> 57 ..etc leading us to require a funky offset.
// this is caused by a transparent column  of the map their app tries to remove
function tiledIndex(i, width, height) {
    let yIndex = Math.floor(i / width) - 1;
    let xOffset = 1 * yIndex;
    xOffset += 1;
    return i + xOffset;
}

// Returns the sprite index for a element in a sheet
function indexForSprite(x, y, width, height) {
    let hofs = y * width;
    return hofs + x;
}

// Noise

// http://mrl.nyu.edu/~perlin/noise/
// https://github.com/mrdoob/three.js/tree/master/examples/js
let ImprovedNoise = function () {

    let p = [151, 160, 137, 91, 90, 15, 131, 13, 201, 95, 96, 53, 194, 233, 7, 225, 140, 36, 103, 30, 69, 142, 8, 99, 37, 240, 21, 10,
        23, 190, 6, 148, 247, 120, 234, 75, 0, 26, 197, 62, 94, 252, 219, 203, 117, 35, 11, 32, 57, 177, 33, 88, 237, 149, 56, 87,
        174, 20, 125, 136, 171, 168, 68, 175, 74, 165, 71, 134, 139, 48, 27, 166, 77, 146, 158, 231, 83, 111, 229, 122, 60, 211,
        133, 230, 220, 105, 92, 41, 55, 46, 245, 40, 244, 102, 143, 54, 65, 25, 63, 161, 1, 216, 80, 73, 209, 76, 132, 187, 208,
        89, 18, 169, 200, 196, 135, 130, 116, 188, 159, 86, 164, 100, 109, 198, 173, 186, 3, 64, 52, 217, 226, 250, 124, 123, 5,
        202, 38, 147, 118, 126, 255, 82, 85, 212, 207, 206, 59, 227, 47, 16, 58, 17, 182, 189, 28, 42, 223, 183, 170, 213, 119,
        248, 152, 2, 44, 154, 163, 70, 221, 153, 101, 155, 167, 43, 172, 9, 129, 22, 39, 253, 19, 98, 108, 110, 79, 113, 224, 232,
        178, 185, 112, 104, 218, 246, 97, 228, 251, 34, 242, 193, 238, 210, 144, 12, 191, 179, 162, 241, 81, 51, 145, 235, 249,
        14, 239, 107, 49, 192, 214, 31, 181, 199, 106, 157, 184, 84, 204, 176, 115, 121, 50, 45, 127, 4, 150, 254, 138, 236, 205,
        93, 222, 114, 67, 29, 24, 72, 243, 141, 128, 195, 78, 66, 215, 61, 156, 180];

    for (let i = 0; i < 256; i++) {
        p[256 + i] = p[i];
    }

    function fade(t) {
        return t * t * t * (t * (t * 6 - 15) + 10);
    }

    function lerp(t, a, b) {
        return a + t * (b - a);
    }

    function grad(hash, x, y, z) {

        let h = hash & 15;
        let u = h < 8 ? x : y, v = h < 4 ? y : h == 12 || h == 14 ? x : z;
        return ((h & 1) == 0 ? u : -u) + ((h & 2) == 0 ? v : -v);

    }

    return {

        noise: function (x, y, z) {

            let floorX = Math.floor(x), floorY = Math.floor(y), floorZ = Math.floor(z);

            let X = floorX & 255, Y = floorY & 255, Z = floorZ & 255;

            x -= floorX;
            y -= floorY;
            z -= floorZ;

            let xMinus1 = x - 1, yMinus1 = y - 1, zMinus1 = z - 1;

            let u = fade(x), v = fade(y), w = fade(z);

            let A = p[X] + Y, AA = p[A] + Z, AB = p[A + 1] + Z, B = p[X + 1] + Y, BA = p[B] + Z, BB = p[B + 1] + Z;

            return lerp(w, lerp(v, lerp(u, grad(p[AA], x, y, z),
                grad(p[BA], xMinus1, y, z)),
                lerp(u, grad(p[AB], x, yMinus1, z),
                    grad(p[BB], xMinus1, yMinus1, z))),
                lerp(v, lerp(u, grad(p[AA + 1], x, y, zMinus1),
                    grad(p[BA + 1], xMinus1, y, z - 1)),
                    lerp(u, grad(p[AB + 1], x, yMinus1, zMinus1),
                        grad(p[BB + 1], xMinus1, yMinus1, zMinus1))));

        }
    };
};

function generateHeight(width, height) {
    let size = width * height, data = new Uint8Array(size),
        perlin = new ImprovedNoise(), quality = 1, z = Math.random() * 100;
    for (let j = 0; j < 4; j++) {
        for (let i = 0; i < size; i++) {
            let x = i % width, y = ~~(i / width);
            data[i] += Math.abs(perlin.noise(x / quality, y / quality, z) * quality * 1.75);
        }
        quality *= 5;
    }
    return data;
}

